module.exports = __webpack_public_path__ + "static/hero-top-3-a5ada146838797f812ba3d3da84e84a0.png";